import create from 'zustand';

import { songTypes } from '@/types';

interface Songs {
  songs: songTypes.Song[];
  setSongs: (data: songTypes.Song[]) => void;
  addSong: (data: songTypes.Song) => void;
}

const songsStore = create<Songs>((set) => ({
  songs: [],

  setSongs: (data: songTypes.Song[]) => set({ songs: data }),

  addSong: (data: songTypes.Song) => set((state) => ({ songs: [data, ...state.songs] })),
}));

export default songsStore;
